// components/ParametersPanel.js
import React from 'react';

const ParametersPanel = ({ 
  showParameters, 
  scoringParams, 
  updateParameter, 
  updateTimeEstimate 
}) => {
  return (
    <div className={`parameters-panel ${showParameters ? '' : 'hidden'}`}>
      <h3>Scoring Parameters</h3>
      
      <div className="param-group">
        <h4>Complexity Weights</h4>
        
        <div className="param-item">
          <label>Worksheets: {scoringParams.worksheetWeight}</label>
          <input 
            type="range" 
            min="1" 
            max="10" 
            value={scoringParams.worksheetWeight}
            onChange={(e) => updateParameter('worksheet', e.target.value)}
            className="param-slider"
          />
        </div>
        
        <div className="param-item">
          <label>Data Volume: {scoringParams.volumeWeight}</label>
          <input 
            type="range" 
            min="1" 
            max="10" 
            value={scoringParams.volumeWeight}
            onChange={(e) => updateParameter('volume', e.target.value)}
            className="param-slider"
          />
        </div>
        
        <div className="param-item">
          <label>Formulas: {scoringParams.formulaWeight}</label>
          <input 
            type="range" 
            min="1" 
            max="10" 
            value={scoringParams.formulaWeight}
            onChange={(e) => updateParameter('formula', e.target.value)}
            className="param-slider"
          />
        </div>
        
        <div className="param-item">
          <label>Macros/VBA: {scoringParams.macroWeight}</label>
          <input 
            type="range" 
            min="1" 
            max="10" 
            value={scoringParams.macroWeight}
            onChange={(e) => updateParameter('macro', e.target.value)}
            className="param-slider"
          />
        </div>
      </div>
      
      <div className="param-group">
        <h4>Time Estimates (weeks)</h4>
        
        <div className="param-item">
          <label>Simple: {scoringParams.timeEstimates.simple.min}-{scoringParams.timeEstimates.simple.max}</label>
          <input 
            type="range" 
            min="1" 
            max="8" 
            value={(scoringParams.timeEstimates.simple.min + scoringParams.timeEstimates.simple.max) / 2}
            onChange={(e) => updateTimeEstimate('simple', e.target.value)}
            className="param-slider"
          />
        </div>
        
        <div className="param-item">
          <label>Medium: {scoringParams.timeEstimates.medium.min}-{scoringParams.timeEstimates.medium.max}</label>
          <input 
            type="range" 
            min="4" 
            max="16" 
            value={(scoringParams.timeEstimates.medium.min + scoringParams.timeEstimates.medium.max) / 2}
            onChange={(e) => updateTimeEstimate('medium', e.target.value)}
            className="param-slider"
          />
        </div>
        
        <div className="param-item">
          <label>Complex: {scoringParams.timeEstimates.complex.min}-{scoringParams.timeEstimates.complex.max}</label>
          <input 
            type="range" 
            min="12" 
            max="36" 
            value={(scoringParams.timeEstimates.complex.min + scoringParams.timeEstimates.complex.max) / 2}
            onChange={(e) => updateTimeEstimate('complex', e.target.value)}
            className="param-slider"
          />
        </div>
      </div>
    </div>
  );
};

export default ParametersPanel;